module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0b8b6b69c311fff2fba742b6c323fbe6.png";